import React, { useState } from "react";
import { Box } from "@mui/material";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Input = styled.input.attrs((props) => props)`
  outline: none;
  border: none;
  width: 120px;
  height: 44px;
  padding-inline: 1rem;
  color: #1e293b;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;

  &::placeholder {
    color: #64748b;
  }

  &:focus {
    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
    box-shadow: 0 4px 12px rgba(148, 163, 184, 0.2);
  }
`;
export default function Searchbar() {
  const { t } = useTranslation("layout");
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchText.trim()) {
      navigate(`/shipment/${searchText}`);
      setSearchText("");
    }
  };

  return (
    <Box
      component="form"
      sx={{
        display: "flex",
        placeItems: "center",
        position: "relative",
      }}
      onSubmit={handleSubmit}
    >
      <Input
        type="text"
        placeholder={t("Navbar.search_placeholder")}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        required
        style={{ paddingRight: "50px" }}
      />
      <Box
        component="button"
        type="submit"
        sx={{
          position: "absolute",
          right: "8px",
          display: "grid",
          placeItems: "center",
          width: "36px",
          height: "36px",
          border: "none",
          background: "#f2a900",
          borderRadius: "8px",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 4px 14px 0 rgba(102, 126, 234, 0.4)",
          "&:hover": {
            transform: "scale(1.05)",
            boxShadow: "0 7px 20px 0 rgba(102, 126, 234, 0.5)",
          },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </Box>
    </Box>
  );
}
